import RatingDetailContainer from './RatingDetailContainer';
export default RatingDetailContainer;
